import { ReactComponent } from './pv-sun-xl.svg';
export const PvSunIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=pv-sun-xl.js.map